import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import AnyResidentInput from '@/shared/residents/components/AnyResidentInput';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {ResidentOptions} from '../../utils/exportOptions';

const ResidentOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<ResidentOptions>) => {
  const {t} = useTranslation();

  return (
    <FormField
      control={form.control}
      name="options.residentId"
      render={({field}) => (
        <FormItem>
          <FormLabel required>{t('Resident')}</FormLabel>
          <FormControl>
            <AnyResidentInput
              value={field.value}
              onChange={field.onChange}
              inputProps={{placeholder: t('Select a resident')}}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ResidentOptionsFields;
